import React from 'react';
import { useSearchParams } from 'react-router-dom';
import EventFeedbackForm from '../components/events/EventFeedbackForm';
import '../styles/event-feedback.css';

export default function EventFeedback() {
  const [searchParams] = useSearchParams();
  const eventName = searchParams.get('eventName') || '';

  return (
    <main className="event-feedback-v2-page" aria-labelledby="event-feedback-v2-title">
      <section className="event-feedback-v2-hero">
        <p className="event-feedback-v2-eyebrow">Lead With Tech</p>
        <h1 id="event-feedback-v2-title">Event Feedback</h1>
        <p className="event-feedback-v2-subtitle">
          Your feedback helps us improve every session, trainer interaction, and learning flow.
          It takes under 2 minutes.
        </p>
        {eventName && (
          <p className="event-feedback-v2-event-pill" aria-label="Selected event name">
            Event: {eventName}
          </p>
        )}
      </section>

      <section className="event-feedback-v2-content" aria-label="Feedback form and context">
        <aside className="event-feedback-v2-aside">
          <h2>What happens after you submit?</h2>
          <ul>
            <li>Your response is reviewed by the team.</li>
            <li>Actionable suggestions feed directly into upcoming sessions.</li>
            <li>High-impact feedback is prioritized in the next cohort improvements.</li>
          </ul>

          <div className="event-feedback-v2-note">
            Honest feedback is valuable. You can be direct and specific.
          </div>
        </aside>

        <div className="event-feedback-v2-form-shell">
          <EventFeedbackForm initialEventName={eventName} />
        </div>
      </section>
    </main>
  );
}
